import {define, singleton} from '@injex/core';
import EntityRequestAdapter from '../utils/EntityRequestAdapter';

export interface ICapitalApp {
    scope: string;
    displayName: string;
    clientUrl: string;
    iconUrl: string;
}

@define('capitalAppsApi')
@singleton()
export class CapitalAppsApi extends EntityRequestAdapter {
    protected basePathName = 'apps';
    protected get apiEndpoint(): string { return this.env.capitalAPI; }

    public async getApps(): Promise<ICapitalApp[]> {
        const response = await this.requestWithContext<ICapitalApp[]>({method: 'get', url: this.makeAPIPath('/')});
        if (!Array.isArray(response?.data)) throw new Error('Could not load applications');
        return response.data;
    }
}
